import React from 'react';
import SeverityCircle from '../../../shared/SeverityCircle';
import Card from '../../../shared/Card';
import FormattedSummary from '../../../shared/FormattedSummary';

type Props = {
  conductScore: number;
  summaryText?: string;
  threadOpen: boolean;
  onToggleThread: () => void;
};

const SeveritySummaryCard: React.FC<Props> = ({ conductScore, summaryText, threadOpen, onToggleThread }) => {
  return (
    <div className="flex items-start gap-3">
      <div className="flex flex-col items-center">
        <SeverityCircle score={conductScore} size="large" />
        <p className="text-figma-xs text-figma-text-secondary mt-2 text-center">Conduct<br/>Score</p>
      </div>
      <div className="flex-1">
        <Card>
          <FormattedSummary className="text-figma-sm text-figma-text-primary" text={summaryText} />
          <button
            onClick={(e) => { e.stopPropagation(); onToggleThread(); }}
            className="mt-3 inline-flex items-center gap-2 text-figma-sm text-go-primary border border-go-primary px-3 py-2 rounded-lg hover:bg-figma-bg-vanilla"
            aria-pressed={threadOpen}
          >
            {threadOpen ? 'Hide Customer Thread' : 'View Customer Thread'}
          </button>
        </Card>
      </div>
    </div>
  );
};

export default React.memo(SeveritySummaryCard);
